var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"2455cd28fa2d744d667697b17767e713d2895510"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/* eslint-disable filenames/match-regex */
import * as Sentry from '@sentry/nextjs'

import { defaultSentryClientConfig } from '@twisto/nextjs/sentry-config'

Sentry.init({
  ...defaultSentryClientConfig,
  dsn: 'https://d4f48ea4e5d95b8311105b5958a21e23@o430641.ingest.sentry.io/4506588605710336',
})
